// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator, mapTags } from '@gandi/translate';

import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

import { ListRow } from '../../ListRow';

import { DetailRow } from './components/Rows';
import Price from './components/Rows/Price';

type Props = { product: DecoratedProduct };

export default function DomainTrusteeOption({
  product,
}: Props): React.MixedElement {
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();
  const { __ } = useTranslator();

  const detail = mapTags(
    __(
      'Allows you to meet the residence conditions required by the registry for this extension. [[LearnMore:]].',
    ),
    () => ({
      LearnMore: (
        <a
          href={__(
            'https://docs.gandi.net/en/domain_names/domain_services/trustee_service.html',
          )}
          target="_blank"
          rel="noopener"
        >
          {__('Learn more')}
        </a>
      ),
    }),
  );

  const label = __('Trustee service for %(fqdn)s', {
    // payload is only available in case of create or transfer
    // identifier is available in case of a renew
    fqdn: product.payload?.fqdn || product.identifier || '',
  });

  if (FF_CART_OVERVIEW_NDS)
    return (
      <ListRow
        title={label}
        options={[detail]}
        optionsArrow={false}
        price={<Price price={product.unitPrice} />}
      />
    );

  /* Legacy style */
  return (
    <DetailRow
      price={product.isWorking ? undefined : product.unitPrice}
      label={label}
      detail={detail}
    />
  );
}
